import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

/** Where a person is in a multi-step flow, in words as well as colour. */
export function Stepper({
  steps,
  current,
  label = "Progress",
}: {
  steps: string[];
  current: number;
  label?: string;
}) {
  return (
    <ol data-slot="stepper" aria-label={label} className="flex flex-wrap gap-x-6 gap-y-3">
      {steps.map((step, index) => {
        const done = index < current;
        const active = index === current;
        return (
          <li key={step} className="flex items-center gap-3" aria-current={active ? "step" : undefined}>
            <span
              aria-hidden
              className={cn(
                "grid size-8 place-items-center rounded-pill border text-sm",
                done && "border-control bg-control text-[var(--control-glyph)]",
                active && "border-accent text-foreground",
                !done && !active && "border-line text-muted",
              )}
            >
              {done ? <Check className="size-4" strokeWidth={2} /> : index + 1}
            </span>
            <span className={cn("text-sm", active ? "font-medium text-foreground" : "text-secondary")}>{step}</span>
            <span className="sr-only">{done ? " (done)" : active ? " (current step)" : ""}</span>
          </li>
        );
      })}
    </ol>
  );
}
